import { ScaleDefinition } from './dynamic-scale.model';

export interface ValidationRule {
  name: string;
  validator: string;
  message: string;
}

export enum FieldTypeENUM {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
  RADIOBUTTON = 'radiobutton',
  TOGGLE = 'toggle',
  UPLOADFILE = 'uploadfile',
  TEXTAREA = 'textarea',
  SECTION = 'section',
  ACCORDION = 'accordion',
  PRIORITY = 'priority',
  TYPOLOGY = 'typology',
  MONISER = 'moniser',

  /// SCALE
  BARTHEL_SCALE = 'BARTHEL_SCALE',
  BRADEN_SCALE = 'BRADEN_SCALE',
  MINIMENTAL_SCALE = 'MINIMENTAL_SCALE',
  NRS_SCALE = 'NRS_SCALE',
  VAS_SCALE = 'VAS_SCALE',
  MAS = 'MAS',
  NDI = 'NDI',
  RMDQ = 'RMDQ',
  SPPB = 'SPPB',
  NINE_HOLE_PEG_TEST_SCALE = 'NINE_HOLE_PEG_TEST_SCALE',
  CAT = 'CAT',
  DASH = 'DASH',
  IPAQ = 'IPAQ',
  MOTRICITY = 'MOTRICITY',
  TCT = 'TCTtct',

  // NUOVE
  NAZIONE = 'nazione',
  REGIONI_PROVINCE_COMUNI = 'regioni-province-comuni',
  EMAIL = 'email',
  TELEFONO = 'telefono',
  CODICE_FISCALE = 'codice-fiscale',
}

export type DynamicType =
  | 'title'
  | 'description'
  | 'sectionTitle'
  | 'sectionDescription'
  | 'field'
  | 'option';

export interface IDynamicForm {
  id?: string;
  title: string;
  description?: string;
  sections: ISection[];
  template?: string;
}

export interface ISection {
  id?: string;
  title?: string;
  description?: string;
  fields?: IFields[];
  required?: boolean;
}

export interface FieldOption {
  name?: string;
  label?: string;
  id?: string | number;
  disabled?: boolean;
  selected?: boolean;
}

export interface IFields {
  id?: string;
  type?: FieldTypeENUM;
  label?: string;
  required?: boolean;
  min?: number;
  max?: number;
  options?: FieldOption[];
  placeholder?: string;
  value?: string | number | boolean | Date;
  disabled?: boolean;
  fields?: IFields[];
  config?: ScaleDefinition;
  endpoint?: string;
  hasCondition?: boolean;
  conditionFieldId?: string;
  conditionValue?: string | number | boolean;
}
